// removed by extract-text-webpack-plugin
module.exports = {"banner":"banner__banner__1xEq7","subtitle":"banner__subtitle__Tjfm1","link":"banner__link__2g9Cq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/banner/banner.scss
// module id = 215
// module chunks = 0